<template>
  <div class="links-auths">
    <div class="text-align-r mt-3 mb-3" v-if="login">
      {{ $t("REGISTER").HasAccount }}
      <a class="forgot-pass cursor-pointer" @click="openLogin">{{
        $t("LOGIN").Click_Here
      }}</a>
    </div>
    <div class="text-align-r mt-3 mb-3" v-if="register">
      {{ $t("LOGIN").New_Here }}
      <a class="forgot-pass cursor-pointer" @click="openRegister">{{
        $t("LOGIN").Register
      }}</a>
    </div>
    <div class="text-align-r mt-3 mb-3" v-if="forgotPass">
      <a class="forgot-pass cursor-pointer" @click="openForgotPassword">{{
        $t("LOGIN").ForgotPass
      }}</a>
    </div>
    <div class="text-align-r mt-3" v-if="lostAccess">
      {{ $t("LOGIN").Lost_Acess }}
      <a class="forgot-pass cursor-pointer" @click="openLostAccess">{{
        $t("LOGIN").Click_Here
      }}</a>
    </div>
  </div>
</template>

<script>
import AppConstants from '../../appConstants';
import router from "@/router";
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";
export default {
  props: {
    login: {
      type: Boolean,
      default: false
    },
    register: {
      type: Boolean,
      default: false
    },
    forgotPass: {
      type: Boolean,
      default: false
    },
    lostAccess: {
      type: Boolean,
      default: false
    },
    fromPopup: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openLogin() {
      if (this.fromPopup) {
        this.$emit('open-login');
      } else {
        router.push({ path:  checkDeviceTypeHelper.getUrlLogin()});
      }
    },
    openForgotPassword() {
      if (this.fromPopup) {
        this.$emit('open-forgot-password');
      } else {
        this.$emit("persist-email-store");
        this.$router.push(AppConstants.NAVIGATION_PAGE_FORGOT_PASSWORD);
      }
    },
    openLostAccess() {
      if (this.fromPopup) {
        this.$emit('open-lost-access');
      } else {
        this.$emit("persist-email-store");
        this.$router.push(AppConstants.NAVIGATION_PAGE_LOST_ACCESS);
      }
    },
    openRegister() {
      if (this.fromPopup) {
        this.$emit('open-register');
      } else {
        this.$router.push(AppConstants.NAVIGATION_PAGE_REGISTER);
      }
    },
  },
};
</script>

<style>
</style>
